import React from "react";

export default function ContactMeBtn() {
  return (
    <div className="container">
      <div className="d-flex justify-content-center">
        <a
          href="https://www.instagram.com/moshe_dyn/"
          className="contactme-btn btn rounded-4"
          target="_blank"
        >
          Contact Me
        </a>
      </div>
    </div>
  );
}
